
import React from 'react'
import { useNavigate } from 'react-router-dom'
import WaterPreMainWorkCard from './WaterPreMainWorkCard'
import { useAuthState } from '../../../../../Helper/Context';

export default function WaterPreMainWorkCardManage(props) {
    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName, DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user

    const WaterPreMainWorkCardNavigate = (name, screenFlag) => {
        if (name === "Operation Works") {
            navigate(`/commonwatersupplypreventivemaintainanceworkpage?name=${name}&ApiFlag=Operation&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}&M_Distri_WorkTypeID=2`)
        }
        else if (name === "Electrical Work Maintainance") {
            navigate(`/commonwatersupplypreventivemaintainanceworkpage?name=${name}&ApiFlag=Electrical&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}&M_Distri_WorkTypeID=4`)
        }
        else if (name === "Mechanical Work Maintainance") {
            navigate(`/commonwatersupplypreventivemaintainanceworkpage?name=${name}&ApiFlag=Mechanical&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}&M_Distri_WorkTypeID=3`)
        }
        else if (name === "Other Works") {
            navigate(`/commonwatersupplypreventivemaintainanceworkpage?name=${name}&ApiFlag=Mechanical&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&DashProjectTypeId=${DashProjectTypeId}&M_Distri_WorkTypeID=3`)
        }
    }
    const navigate = useNavigate()

    return (

        <div className='row ml-0 mr-0'>
            <div className="col-lg-3 col-md-6 mb-2" >
                <WaterPreMainWorkCard
                    title='Operation Works'
                    count={Countdata.OperationWorkTotalCount ? Countdata.OperationWorkTotalCount : '0'}
                    imgPath='./assets/img/engineering.png'
                    cardCss='p-3 shadow blue_borders mb-md-2 daily-card-width '
                    navLink='/commonwatersupplypreventivemaintainanceworkpage'
                    countText='green_color'
                    WaterPreMainWorkCardNavigate={WaterPreMainWorkCardNavigate}
                />
            </div>

            <div className="col-lg-3 col-md-6 mb-2">
                <WaterPreMainWorkCard
                    title='Electrical Work Maintainance'
                    count={Countdata.ElectricalWorkTotalCount ? Countdata.ElectricalWorkTotalCount : '0'}
                    imgPath='./assets/img/renewable-energy.png'
                    cardCss='p-3 shadow blue_borders mb-md-2 daily-card-width '
                    navLink='/roadworkapproval'
                    countText='green_color'
                    WaterPreMainWorkCardNavigate={WaterPreMainWorkCardNavigate}

                />
            </div>

            <div className="col-lg-3 col-md-6 mb-2" >
                <WaterPreMainWorkCard
                    title='Mechanical Work Maintainance'
                    count={Countdata.MechanicalWorkTotalCount ? Countdata.MechanicalWorkTotalCount : '0'}
                    imgPath='./assets/img/mechanics.png'
                    cardCss='p-3 shadow blue_borders mb-md-2 daily-card-width '
                    navLink='/roadworkapproval'
                    countText='green_color'
                    WaterPreMainWorkCardNavigate={WaterPreMainWorkCardNavigate}

                />
            </div>

            <div className="col-lg-3 col-md-6 mb-2" >
                <WaterPreMainWorkCard
                    title='Other Works'
                    count={0}
                    imgPath='./assets/img/mechanics.png'
                    cardCss='p-3 shadow blue_borders mb-md-2 daily-card-width '
                    navLink='/roadworkapproval'
                    countText='green_color'
                    WaterPreMainWorkCardNavigate={WaterPreMainWorkCardNavigate}

                />
            </div>
        </div>

    )
}






